module.exports = __webpack_public_path__ + "c8d9be5f6b074c16abe2799a554d0066.svg";